$(document).ready(function(){
    function ajaxContent(dataUrl, dataTarget){
        var History = window.History,
            $container = $('.suite-inner-container'),
            $spinner = $('.fa-spinner')

        if(history.pushState){
            history.pushState(null, document.title, dataUrl);
        }else{
            History.pushState(null, document.title, dataUrl.toString());
        }

        $.ajax({
            url: dataUrl,
            beforeSend: function(){
                $container.removeClass('active');
                $spinner.addClass('active');
            },
            success: function(response){
                var html = $(response).find(dataTarget).html();
                $(dataTarget).html(html);
                $container.addClass('active');
                $spinner.removeClass('active');
            }
        });
    }

    // Filter categories
    $('#sort-element').on('input', function(e){
        e.preventDefault();

        var $this = $(this),
            val = $this.val(),
            url = window.location.href.split('?')[0] + '?sort=' + val;

        ajaxContent(url, '.suite-container');
    });
});